import { HttpRequestVerbs } from "constants/network";
import { sendMultiScreenEventToTv } from "services/helpers/multiScreen";
import { PlayerEvent } from "shared-types/player-event";
import { useSelector } from "react-redux";
import { blindTestSelector } from "@redux/blindTest/selectors";
import analytics from "lib/analytics";
import { useState } from "react";

export function useBlindTest() {
	const blindTest = useSelector(blindTestSelector);
	const [isClickDisabled, setIsClickDisabled] = useState(false);

	const openBlindTestTabs = async () => {
		if (isClickDisabled) {
			return;
		}

		setIsClickDisabled(true);

		setTimeout(() => {
			setIsClickDisabled(false);
		}, 5000);

		if (!blindTest) {
			console.error("Blind test not available");
			return;
		}

		sendMultiScreenEventToTv(PlayerEvent.PAUSE);

		analytics.track("open_blind_test");

		const params = new URLSearchParams();
		params.append("urlController", blindTest.urlController);
		params.append("urlDisplay", blindTest.urlDisplay);

		return fetch(
			`${process.env.REACT_APP_LOCAL_API_BASE_URL}/blind-test?${params}`,
			{
				method: HttpRequestVerbs.POST,
			},
		).catch((error) => {
			console.error(`Open blind test fail. Error: ${error}`);
		});
	};

	const resetBlindTest = async () => {
		if (!blindTest) {
			return;
		}

		fetch(blindTest.urlReset, {
			method: HttpRequestVerbs.POST,
			headers: {
				"x-amusoire-bam-auth": process.env.REACT_APP_AMUSOIRE_KEY ?? "",
			},
		}).catch((error) => {
			console.error(`Reset blind test fail. Error: ${error}`);
		});

		fetch(
			`${process.env.REACT_APP_LOCAL_API_BASE_URL}/close-blind-test`,
			{
				method: HttpRequestVerbs.POST,
			},
		).catch((error) => {
			console.error(`Close blind test fail. Error: ${error}`);
		});
	};

	return { openBlindTestTabs, resetBlindTest, blindTest };
}
